import * as Noty from "noty";

export class NotificationService{
    public static $inject = ['notifications'];
    constructor(public notifications:any) {
    }

    notify(msg:string, timeout:number=5000){
        //alert("notificationService:"+msg);
        //this.notifications.showSuccess({message: msg});
        console.log("notify="+msg);
        new Noty({
            text: "<span style='font-size:14px;font-weight:bold;'>" + msg + "</span>",
            type: 'information',
            layout: 'top',
            timeout: timeout == null ? 8000 : timeout,
            closeWith: ['click']
        }).show();
    }


    notifyError(msg:string, err:any="", timeout:number=10000){
        var fromErr = "";
        if(err === null && err.message !== null)
            fromErr = err.message;
        else if(err !== null)
            fromErr = err;
        new Noty({
            text: "<span style='font-size:14px;font-weight:bold;'>" + msg + fromErr + "</span>",
            type: 'error',
            layout: 'top',
            timeout: timeout == null ? 8000 : timeout,
            closeWith: ['click']
        }).show();
    }
}
